// DetailTooltip.jsx
const DetailTooltip = ({
  title,
  text,
  children,
  ...props
}) => {
  const tooltipContent = [title, text].filter(Boolean).join("\n"); // line break for multi-line tooltip

  return (
    <span title={tooltipContent} {...props} style={{ cursor: "pointer" }}>
      {children}
    </span>
  );
};

export default DetailTooltip;
